/**
 * Constant strings. These are the types, attributes etc. used on Contentful.
 */

export const CUSTOM_ORDER_NOW = 'OrderNow'
export const CUSTOM_SEND_REQUEST = 'SendRequest'
export const CUSTOM_SEND_REQUEST_REQUIRED_MESSAGE = 'SendRequestRequiredMessage'
export const CUSTOM_NUMBER_OF_CARS = 'NumberOfCars'
export const CUSTOM_CONTACT_INFO = 'ContactInformation'
export const CUSTOM_TEXT_ONLY = 'TextOnly'
export const CUSTOM_TRIPS_TIME_INTERVAL = 'TripsTimeInterval'
export const CUSTOM_WORKSHOP_TIME_INTERVAL = 'WorkshopTimeInterval'
export const CUSTOM_ODOMETER_START = 'OdometerOptionalStart'
export const CUSTOM_ODOMETER_END = 'OdometerOptionalEnd'
export const CUSTOM_ODOMETER_DATED = 'OdometerDated'
export const CUSTOM_CONTRACT_INPUT = 'ContractInput'
export const CUSTOM_TAXOFFICE_INPUT = 'TaxOfficeInput'
export const CUSTOM_CAR_COMPATIBLE = 'CarCompatibleConfirmation'
export const CUSTOM_CAR_INPUT = 'VehicleInput'
export const CUSTOM_LINKS_ONLY = 'LinksOnly'

export const ATTRIBUTE_NAME = 'name'
export const ATTRIBUTE_EMAIL = 'requestEmail'
export const ATTRIBUTE_PHONE = 'telephone'
export const ATTRIBUTE_ODOMETER = 'odometer'
export const ATTRIBUTE_ODOTIMESTAMP = 'odometerTimestamp'
export const ATTRIBUTE_INTEREST = 'interestedIn'
export const ATTRIBUTE_CAR = 'car-group'
export const ATTRIBUTE_ENGINE = 'engineType'
export const ATTRIBUTE_BYEAR = 'builtYear'
export const ATTRIBUTE_CLASS = 'class'
export const ATTRIBUTE_DCONFIG = 'dongleConfiguration'
export const ATTRIBUTE_CARDATA = 'carData'
export const ATTRIBUTE_CUSTOMERID = 'customerNumber'
export const ATTRIBUTE_TAXOFFICE = 'taxOffice'
export const ATTRIBUTE_AFFECTEDCAR = 'affectedCar'
export const ATTRIBUTE_NUMBERCARS = 'numberOfCars'
export const ATTRIBUTE_STARTSERVODO = 'startServiceOdometer'
export const ATTRIBUTE_ENDSERVODO = 'endServiceOdometer'
export const ATTRIBUTE_STARTSERVTIMESTAMP = 'startServiceTimestamp'
export const ATTRIBUTE_ENDSERVTIMESTAMP = 'endServiceTimestamp'
export const ATTRIBUTE_PRIORITY = 'priority'
export const ATTRIBUTE_TRIPSSTART = 'tripsStart'
export const ATTRIBUTE_TRIPSEND = 'tripsEnd'
export const ATTRIBUTE_COMPANY = 'company'
export const ATTRIBUTE_CHECKBOXES = 'checkboxes'

export const ATTRIBUTE_CLIENTID_CLIENT = 'clientClientId'
export const ATTRIBUTE_USERID_CLIENT = 'clientUserId'
export const ATTRIBUTE_NAME_CLIENT = 'clientUserName'
export const ATTRIBUTE_EMAIL_CLIENT = 'clientUserEmail'

export const ATTRVALUE_CLASS_INTERESSENT = 'Interessent'
export const ATTRVALUE_INTEREST_FLEET = 'fleet'
export const ATTRVALUE_INTEREST_LOGBOOK = 'logbook'
export const ATTRVALUE_DESTINATION_PIPEDRIVE = 'pipedrive'
export const ATTRVALUE_DESTINATION_ZENDESK = 'zendesk'
export const ATTRVALUE_PRIORITY_LOW = 'low'
export const ATTRVALUE_PRIORITY_NORMAL = 'normal'
export const ATTRVALUE_PRIORITY_HIGH = 'high'

export const NODE_SELECT = 'selectNode'
export const NODE_CUSTOM = 'customNode'
export const NODE_VALUED = 'valuedNode'
export const NODE_COMPLEX = 'complexNode'
export const NODE_LINK = 'selectNodeLink'
